module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/diseases/leg-9fa7601562a6e33db61d8a4d9c4120c4.png";